






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ChartProgress from './ChartProgress.vue'
import ChartBar from './ChartBar.vue'
import { convertMinutesToTimeJp } from '../../../../lib/convert'

@Component({
  components: {
    ChartProgress,
    ChartBar
  }
})
export default class DashboardTimeSummary extends Vue {
  @Prop({ default: null })
  timeGraphData: {
    labels: string[]
    datasets: {
      [x: string]: any
      label: string
      data: number[]
    }[]
  }

  @Prop()
  startDate: Date

  @Prop()
  endDate: Date

  @Prop({ default: 100 })
  height: number

  @Prop({ default: null })
  width: number

  chartOptions = {
    elements: {
      line: {
        tension: 0
      }
    },
    legend: {
      display: false
    },
    scales: {
      x: [
        {
          // display: false
        }
      ],
      y: [
        {
          display: false,
          ticks: {
            beginAtZero: true
          }
        }
      ]
    },
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label || '';

          if (label) {
              label += ': ';
          }
          const minutes = Math.round(tooltipItem.yLabel * 100) / 100;
          label += convertMinutesToTimeJp(minutes);
          return label;
        }
      }
    }
  }
}
